module.exports = __webpack_public_path__ + "static/media/XFerToneB.e7450c1a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/XFerToneB.mp3
// module id = 2606
// module chunks = 0